import { useEffect, useState } from 'react';
import { Modal, Row, Col, Form, Typography, Input, message } from 'antd';
import User from '../../../models/User';
import { ReactComponent as Mail } from '../../../res/svg/mail.svg';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { forgotPassword } from '../../../store/slice/userSlice';
import './AuthModal.less';
/**
 * @component AuthUserModal.tsx
 * @description AuthUserModal component to user authentications.
 * @return { Component }
 */
interface AuthModalProps {
  isModalVisible: boolean;
  user: User;
  buttonText: string;
  closeModal: () => void;
}
function AuthModal(props: AuthModalProps) {
  const [hidden, setHidden] = useState(props.isModalVisible);
  const [title, setTitle] = useState('Restablecer contraseña')
  const [subTitle, setSubTitle] = useState('¡No te preocupes! Ingresa tu correo electrónico y te ayudaremos.')
  const [buttonHidden, setButtonHidden] = useState(false)
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const { Title, Text } = Typography;
  const handleOk = () => {
    if (!buttonHidden) {
      form
      .validateFields()
      .then((values) => {
        dispatch(forgotPassword(values.email)).then((value: any) => {
          if (value.payload.status) {
            setTitle('¡Listo! Revisa tu casilla de correo.')
            setSubTitle(`Hemos enviado un correo a ${values.email} con el link para restablecer tu contraseña.`)
            form.resetFields();
            setButtonHidden(true)
          } else {
            message.error(value.payload.data.message)
          }
        });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
    }else {
      props.closeModal()
    }
  };
  const handleCancel = () => {
    setHidden(!props.isModalVisible);
    props.closeModal();
    form.resetFields();
  };
  useEffect(() => {
    setHidden(props.isModalVisible);
    setTitle('Restablecer contraseña')
    setSubTitle('¡No te preocupes! Ingresa tu correo electrónico y te ayudaremos.')
    setButtonHidden(false)
  }, [props.isModalVisible]);
  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={'Restablecer contraseña'}
            visible={hidden}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={ !buttonHidden ? 'Restablecer' : 'Entendido'}
            className={'org-auth-modal'}
            cancelButtonProps={{ style: { display: 'none' } }}>
            <Title level={5}>{title}</Title>
            <Text className="org-auth-modal__sub__title">
            {subTitle}
            </Text>
            {!buttonHidden &&
            <Form className='org-auth-modal__form' layout={'vertical'} form={form} name="forgotForm">
              <Form.Item
                name={'email'}
                required={true}
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese tu correo electrónico.',
                  },
                  {
                    type: 'email',
                    message: 'Ingresa un correo electrónico válido.',
                  }
                ]}
              >
                <Input     
                  prefix={<Mail />}
                  required
                  placeholder={'Ingresa tu correo electrónico.'}
                />
              </Form.Item>
            </Form>}
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default AuthModal;
